import { environment } from "@environments/environment";
import { Injectable } from "@angular/core";
import { Stripe as StripeClient } from "@stripe/stripe-js";

declare const Stripe: (stripeKey: string) => StripeClient;

@Injectable({
  providedIn: "root",
})
export class StripeService {
  public readonly stripeClient = Stripe(environment.stripeKey) as unknown as StripeClient;
}
